import React, { useState, useEffect } from 'react';
import { connect } from 'shalala';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import { useStore } from '../../../../store';
import CustomDatePicker from './CustomDatePicker';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';

const ReporteNuevosClientesSearch = (props) => {
  const [index, setIndex] = useState();

  const { filters } = props.list;

  useEffect(() => {
    props.listActions.paginate({
      ...filters,
      field: index,
    });
  }, [index]); // eslint-disable-line

  const handleOnKeywordChange = (keyword) => {
    props.listActions.paginate({
      ...filters,
      search: keyword,
    });
  };

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  };

  const handleOnDateChange = (date) => {
    const { from, to } = date;

    props.listActions.paginate({
      ...filters,
      from,
      to,
    });
  };

  const handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    setIndex(id);
  };

  const getOmnisearchLegend = () => {
    let legend = 'Cliente';

    switch (index) {
      case 'razon_social':
        legend = 'Razón Social';
        break;
      case 'nombre_comercial':
        legend = 'Nombre Comercial';
        break;
      case 'rfc':
        legend = 'RFC';
        break;
      case 'email':
        legend = 'Email';
        break;
      default:
        break;
    }

    return legend;
  };

  return (
    <div className="d-flex flex-column flex-sm-row">
      <div className="d-flex flex-column flex-sm-row">
        <CustomDatePicker onDateChange={handleOnDateChange} />

        <div className="pr-2"></div>

        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={handleOnKeywordChange}
            onClear={handleOnSearchClear}
            value={filters.search}
          >
            <DropdownButton
              variant="outline-secondary"
              title={getOmnisearchLegend()}
              id="search-index"
              onSelect={handleOnSelectIndex}
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item id="razon_social">Razón Social</Dropdown.Item>
              <Dropdown.Item id="nombre_comercial">Nombre Comercial</Dropdown.Item>
              <Dropdown.Item id="rfc">RFC</Dropdown.Item>
              <Dropdown.Item id="email">Email</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    </div>
  );
};

const mapState = (store) => {
  return { list: store.admin.reportes.clientes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.admin.reportes.clientes.list };
};

export default connect(useStore, mapState, mapActions)(ReporteNuevosClientesSearch);
